import React from "react";
import { List } from "../modules/Settings/Regions";

export function RegionsListPage() {
  return <List />;
}
